<template lang="pug">
    .forms Forms
</template>
<script>
export default {
  name: 'Forms',
};
</script>